import { RainbowButton } from "components/ui/rainbow-button";
import { useEmbeddedChat } from "src/context/EmbeddedChatContext";
import { useMe } from "src/context/MeContext";
import { isRootlyBranded } from "src/utils/brandTheme";

export default function AskTierZero() {
  const { open } = useEmbeddedChat();
  const me = useMe();
  const brandTheme = me.organization?.brandTheme ?? "TIERZERO";
  const isRootly = isRootlyBranded(brandTheme);

  return (
    <div className="w-full sm:w-auto [&>button]:w-full [&>button]:sm:w-auto [&>button]:justify-center">
      <RainbowButton onClick={open}>
        {isRootly ? "Dig Deeper" : "Ask TierZero"}
      </RainbowButton>
    </div>
  );
}
